module.exports = __webpack_public_path__ + "static/img/female-bg-fr.6638f8e7.png";